import { ButtonIcon, css, MoveIcon, styled, Tooltip } from 'canoe';
import React from 'react';

import { SelectedToolbarMenuCallout } from 'craft/components/SelectedToolbar';
import { TooltipBodyWithShortcuts } from 'craft/components/TooltipBodyWithShortcuts';

export const StyledButtonIcon = styled(ButtonIcon)<{ menuPosition: 'top' | 'bottom' }>`
  ${({ menuPosition }) => css`
    ${menuPosition === 'top' &&
    css`
      transform: rotate(180deg);
    `}
  `}
`;

interface Props {
  dom: HTMLElement | null;
  menuPosition: 'top' | 'bottom';
  onToggleMenuPosition: VoidFunction;
}

export const FloatingMenuContext = ({ dom, menuPosition, onToggleMenuPosition }: Props) => {
  return (
    <SelectedToolbarMenuCallout
      dom={dom}
      calloutPlacement={menuPosition === 'top' ? 'bottom' : 'top'}
    >
      <Tooltip
        placement={menuPosition === 'top' ? 'bottom' : 'top'}
        offset="xxs"
        content={
          <TooltipBodyWithShortcuts
            content={`Move to ${menuPosition === 'top' ? 'Bottom' : 'Top'}`}
          />
        }
      >
        <StyledButtonIcon
          size="small"
          icon={MoveIcon}
          onClick={onToggleMenuPosition}
          radius="small"
          color="white"
          menuPosition={menuPosition}
        />
      </Tooltip>
    </SelectedToolbarMenuCallout>
  );
};
